var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1109.75 636.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#39f;}.cls-2{fill:#93a5a5;}.cls-3{fill:#bdc2c8;}.cls-4{fill:#e84c3d;}.cls-5{fill:#d38753;}.cls-6{fill:#9e653e;}.cls-7{fill:#f8db94;}.cls-8{fill:#f59d1f;}.cls-9{fill:#1ab99b;}.cls-10{fill:#fff;}.cls-11{fill:#975ba5;}.cls-12{fill:#eef3f6;}.cls-13{fill:#ce4c4c;}.cls-14{fill:#e4c15b;}.cls-15{fill:#818f8f;}.cls-16{fill:#f89c1f;}.cls-17{fill:#f0c514;}.cls-18{fill:#3597d4;}.cls-19{fill:#d45729;}.cls-20{fill:#2aad61;}.cls-21{fill:#20a286;}.cls-22{fill:#e77e23;}.cls-23{fill:#1bb79f;}.cls-24{fill:#d08450;}.cls-25{fill:#ce6e56;}.cls-26{fill:#208249;}.cls-27{fill:#9f411f;}.cls-28{fill:#71447c;}.cls-29{fill:#4ac6e0;}.cls-30{fill:#ad5f1a;}.cls-31{fill:#9b3939;}.cls-32{fill:#ae392e;}.cls-33{fill:#f89b22;}.cls-34{fill:#efdc5f;}.cls-35{fill:#34495e;}.cls-36{fill:#1b4c6a;}.cls-37{fill:#190d3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 438.79,
    width: 337.31,
    height: 35.03,
    rx: 15.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.62,35c18.53,0,33.56,13.43,33.56,30h0c0,16.56-15,30-33.56,30H613.2V35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.08,95h5.54a37.33,37.33,0,0,1-5.54-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.08,35v.42a37.32,37.32,0,0,1,5.54-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M645.41,54.56h0A19.53,19.53,0,0,1,664.94,35H607.45V74.1h57.49A19.53,19.53,0,0,1,645.41,54.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 598.26,
    y: 74.1,
    width: 220.77,
    height: 24.94,
    rx: 11.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.22,95h104a0,0,0,0,1,0,0v12.21a15.67,15.67,0,0,1-15.67,15.67H509.22a12.67,12.67,0,0,1-12.67-12.67v-2.54A12.67,12.67,0,0,1,509.22,95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596,134.57a17.24,17.24,0,0,0,17.24-17.24V106.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.69,146.29a11.71,11.71,0,0,1,11.72-11.72H552.67V158h44.74A11.71,11.71,0,0,1,585.69,146.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.55,122.52a10.3,10.3,0,0,1,4.37,8.42v2.35a10.32,10.32,0,0,1-10.32,10.32h19.07l44.74-9,10.1-11.69v-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.43,113.13h0A21.43,21.43,0,0,1,762.86,91.7H686.24a21.43,21.43,0,0,1,21.43,21.43h0a21.43,21.43,0,0,1-21.43,21.44h76.62A21.43,21.43,0,0,1,741.43,113.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M993.79,242.51h0a14.27,14.27,0,0,1,14.27-14.27H957a14.27,14.27,0,0,1,14.27,14.27h0A14.27,14.27,0,0,1,957,256.78h51A14.27,14.27,0,0,1,993.79,242.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M856.72,306.65h0A14.27,14.27,0,0,1,871,292.38H804.7A14.27,14.27,0,0,1,819,306.65h0a14.27,14.27,0,0,1-14.27,14.27H871A14.27,14.27,0,0,1,856.72,306.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 607.51,
    y: 94.54,
    width: 99.17,
    height: 12.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 571.81,
    y: 158,
    width: 138.15,
    height: 38.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.11,212.93h0a16.33,16.33,0,0,1,16.33-16.32H494.25a16.32,16.32,0,0,1,16.32,16.32h0a16.32,16.32,0,0,1-16.32,16.33H598.44A16.33,16.33,0,0,1,582.11,212.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.9,358.56h0a16.32,16.32,0,0,1,16.32-16.32H339.74a16.32,16.32,0,0,1,16.33,16.32h0a16.33,16.33,0,0,1-16.33,16.32h68.48A16.32,16.32,0,0,1,391.9,358.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.27,245.51h0a16.33,16.33,0,0,1,16.33-16.32H257.41a16.32,16.32,0,0,1,16.32,16.32h0a16.32,16.32,0,0,1-16.32,16.33H361.6A16.33,16.33,0,0,1,345.27,245.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.58,118.44h0a16.33,16.33,0,0,1,16.32-16.33H296.72A16.33,16.33,0,0,1,313,118.44h0a16.32,16.32,0,0,1-16.32,16.32H400.9A16.32,16.32,0,0,1,384.58,118.44Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "548.43 143.61 420.71 143.61 420.71 196.61 577.32 196.61 577.32 147.66 552.67 140.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 276.46,
    y: 134.57,
    width: 43.82,
    height: 25.78,
    rx: 11.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.86,
    y: 65.02,
    width: 242.01,
    height: 37.1,
    rx: 16.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 387.68,
    y: 229.19,
    width: 274.32,
    height: 51.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 937.01,
    y: 194.89,
    width: 117.46,
    height: 33.36,
    rx: 15.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 900.85,
    y: 256.78,
    width: 122.07,
    height: 21.87,
    rx: 9.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 771.11,
    y: 320.92,
    width: 139.26,
    height: 35.44,
    rx: 16.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 643.4,
    y: 317.91,
    width: 75.91,
    height: 21.28,
    rx: 9.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.13,
    y: 190.43,
    width: 97.79,
    height: 38.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.84,
    y: 293.45,
    width: 118.63,
    height: 37.61,
    rx: 17.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 244.25,
    y: 261.84,
    width: 75.67,
    height: 20.62,
    rx: 9.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.76,
    y: 317.91,
    width: 68.3,
    height: 24.33,
    rx: 11.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 271.33,
    y: 374.88,
    width: 147.09,
    height: 19.26,
    rx: 8.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.14,
    y: 360.76,
    width: 52.5,
    height: 14.12,
    rx: 6.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 688.72,
    cy: 372.2,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85.28,
    cy: 360.76,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 520.16,
    cy: 65.02,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 962.31,
    cy: 328.55,
    r: 9.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 377.51,
    cy: 30.54,
    r: 9.02,
    transform: "translate(17.32 147.62) rotate(-22.63)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M546.24,469.59a15.18,15.18,0,1,0-15.17-15.18A15.19,15.19,0,0,0,546.24,469.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M985.17,497.75a13.63,13.63,0,0,0-13.61-13.62h-8.73a13.63,13.63,0,0,0-13.61,13.62v2.59h35.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M465.76,516.45a2.48,2.48,0,0,1,2.49-2.49h34a2.49,2.49,0,0,1,2.5,2.49v5.72h95.7v-5.72a2.49,2.49,0,0,1,2.49-2.49h34a2.49,2.49,0,0,1,2.5,2.49v5.72H662V395.81a8.12,8.12,0,0,0-8.11-8.11H451.26a8.11,8.11,0,0,0-8.1,8.11V522.17h22.6Zm103.55-100.9a10.39,10.39,0,1,1-10.39,10.39A10.4,10.4,0,0,1,569.31,415.55Zm-23.07,18.71a20.16,20.16,0,1,1-20.16,20.15A20.18,20.18,0,0,1,546.24,434.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.13,342.91H221a14.66,14.66,0,0,0,14.65-14.65V155.45A14.66,14.66,0,0,0,221,140.8H113.13a14.67,14.67,0,0,0-14.66,14.65V328.26A14.67,14.67,0,0,0,113.13,342.91Zm-7.8-187.46a7.81,7.81,0,0,1,7.8-7.79H221a7.8,7.8,0,0,1,7.79,7.79V328.26a7.8,7.8,0,0,1-7.79,7.79H113.13a7.81,7.81,0,0,1-7.8-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.31,431.35a5.41,5.41,0,1,0-5.4-5.41A5.41,5.41,0,0,0,569.31,431.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.46,309.14a3.12,3.12,0,0,1,6.23,0v8.2a69.18,69.18,0,0,0,16.25-3.63,51.52,51.52,0,0,1-6.89-4.63,2.5,2.5,0,1,1,3.13-3.89,46,46,0,0,0,9.69,6l.18.1a71,71,0,0,0,15.91-10,47.39,47.39,0,0,1-17.36-16.5,2.49,2.49,0,1,1,4.24-2.62,42.39,42.39,0,0,0,17.1,15.55c1.41-1.36,2.8-2.82,4.15-4.37-11.36-12.5-17.8-30.36-10.67-44.42a49.77,49.77,0,0,0-11.16,2.45l-.09.06a6.62,6.62,0,0,0-2.57,3,21.35,21.35,0,0,0-.73,18.16,2.5,2.5,0,0,1-4.58,2,26.16,26.16,0,0,1-.47-19.41A50.72,50.72,0,0,0,488,282.22a50.19,50.19,0,0,0,11.86,13.89,2.49,2.49,0,0,1-3.13,3.88,55,55,0,0,1-10.56-11.35,50.77,50.77,0,0,0-1.11,10.53V317a13.68,13.68,0,0,1,3.4.9Zm31.7-7a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,520.16,302.13Zm2.8-29.46a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,523,272.67Zm-19.33-8.26a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,503.63,264.41Zm-6.19,11.11a2.5,2.5,0,0,1,4.84-1.22,34.48,34.48,0,0,0,12.56,19,2.49,2.49,0,1,1-3,4A39.46,39.46,0,0,1,497.44,275.52Zm1.36,34.71a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,498.8,310.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M484.76,350.35c-.67,9.35-2.14,23.15-5.27,31.12h10.67a36.39,36.39,0,0,1-1.7-11v-18.9A28.61,28.61,0,0,1,484.76,350.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M483.74,342.86l.1.07a19.81,19.81,0,0,0,4.62,2.15v-9.8a12.24,12.24,0,0,1-6.13-4.56c-1.3-2,1.94-3.91,3.23-1.89a7,7,0,0,0,2.9,2.4V325a8.9,8.9,0,0,0-5.21-1.83,5.71,5.71,0,0,0-4,2.34,10.2,10.2,0,0,0-1.39,10.21A14.58,14.58,0,0,0,483.74,342.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 949.22,
    y: 504.09,
    width: 35.96,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 364.15,
    y: 248.35,
    width: 13.36,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 335.45,
    y: 258.64,
    width: 13.36,
    height: 45.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M310,331.06H417.91a2.81,2.81,0,0,0,2.8-2.8V155.45a2.81,2.81,0,0,0-2.8-2.8H310a2.81,2.81,0,0,0-2.8,2.8V328.26A2.81,2.81,0,0,0,310,331.06ZM411.2,216.56V307a2.49,2.49,0,0,1-2.49,2.49H390.36a2.49,2.49,0,0,1-2.5-2.49v-90.4a2.5,2.5,0,0,1,2.5-2.5h18.35A2.5,2.5,0,0,1,411.2,216.56Zm-14.61-56.21h10.68v4h-5.54v1h5.14v4h-5.14v1h5.93v3.95H396.59Zm-21.55,0h7.32l2.27,7.51,2.28-7.51h7.31v13.84h-5.14v-7.71l-2.37,7.71h-4.15l-2.38-7.71v7.71H375Zm-9.68-.3c4.54,0,7.71,3.17,7.71,7.22s-3.17,7.22-7.71,7.22-7.71-3.17-7.71-7.22S360.81,160.05,365.36,160.05Zm-14,0a7.29,7.29,0,0,1,5.54,2.18L354.48,166a4.35,4.35,0,0,0-2.57-1.09,2.37,2.37,0,0,0,0,4.74,4.37,4.37,0,0,0,2.57-1.08l2.38,3.75a7.29,7.29,0,0,1-5.54,2.18,7.22,7.22,0,1,1,0-14.44Zm-23.52.3h5.73l3.36,6.13v-6.13H342v13.84H336.3l-3.36-6.13v6.13H327.8Zm-7.52,0h5.14v13.84h-5.14Zm1.4,20.56h84.59a2.5,2.5,0,0,1,0,5H321.68a2.5,2.5,0,0,1,0-5Zm60.82,65V307a2.49,2.49,0,0,1-2.49,2.49H361.66a2.49,2.49,0,0,1-2.5-2.49v-61.1a2.49,2.49,0,0,1,2.5-2.49H380A2.49,2.49,0,0,1,382.5,245.86Zm-28.7,10.29V307a2.49,2.49,0,0,1-2.5,2.49H333a2.49,2.49,0,0,1-2.49-2.49V256.15a2.5,2.5,0,0,1,2.49-2.5H351.3A2.5,2.5,0,0,1,353.8,256.15ZM319.13,204a2.5,2.5,0,0,1,5,0V315.79h82.09a2.5,2.5,0,1,1,0,5H321.63a2.5,2.5,0,0,1-2.5-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M845.22,255.9l16.92-33.58-33.21-33.94a45.15,45.15,0,0,0,16.29,67.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310,342.91H417.91a14.67,14.67,0,0,0,14.65-14.65V155.45a14.67,14.67,0,0,0-14.65-14.65H310a14.66,14.66,0,0,0-14.65,14.65V328.26A14.66,14.66,0,0,0,310,342.91Zm-7.79-187.46a7.81,7.81,0,0,1,7.79-7.79H417.91a7.81,7.81,0,0,1,7.79,7.79V328.26a7.81,7.81,0,0,1-7.79,7.79H310a7.81,7.81,0,0,1-7.79-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M393.69,431.66h-4.93v3.27a3.59,3.59,0,1,1-7.17,0v-3.27h-7v3.27a3.59,3.59,0,1,1-7.17,0v-3.27h-7v3.27a3.59,3.59,0,1,1-7.17,0v-3.27h-7v3.27a3.59,3.59,0,1,1-7.17,0v-3.27h-7v3.27a3.59,3.59,0,1,1-7.17,0v-3.27h-4.93v87.39h73.77Zm-54.14,83h-13.5a2.49,2.49,0,1,1,0-5h13.5a2.49,2.49,0,1,1,0,5Zm0-12.1h-13.5a2.5,2.5,0,1,1,0-5h13.5a2.5,2.5,0,1,1,0,5Zm0-12.11h-13.5a2.5,2.5,0,1,1,0-5h13.5a2.5,2.5,0,1,1,0,5Zm0-12.1h-13.5a2.5,2.5,0,1,1,0-5h13.5a2.5,2.5,0,1,1,0,5Zm2.5-14.34a2.5,2.5,0,0,1-2.5,2.49h-13.5a2.5,2.5,0,0,1-2.5-2.49V450.47a2.5,2.5,0,0,1,2.5-2.5h13.5a2.5,2.5,0,0,1,2.5,2.5Zm21.51,50.65H350.05a2.49,2.49,0,0,1,0-5h13.51a2.49,2.49,0,1,1,0,5Zm0-12.1H350.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,0,1,0,5Zm0-12.11H350.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,0,1,0,5Zm0-12.1H350.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,0,1,0,5Zm24,36.31H374.05a2.49,2.49,0,0,1,0-5h13.51a2.49,2.49,0,1,1,0,5Zm0-12.1H374.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,1,1,0,5Zm0-12.11H374.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,1,1,0,5Zm0-12.1H374.05a2.5,2.5,0,0,1,0-5h13.51a2.5,2.5,0,1,1,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M403.88,531.52H364.81a1.87,1.87,0,1,1,0-3.74h39.07v-2.5H309.73v2.5H344a1.87,1.87,0,0,1,0,3.74H309.73v4.67h94.15Zm-47.08,0h-5.71a1.87,1.87,0,1,1,0-3.74h5.71a1.87,1.87,0,0,1,0,3.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 136.09,
    y: 258.64,
    width: 13.36,
    height: 45.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 164.79,
    y: 248.35,
    width: 13.36,
    height: 56.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 328.54,
    y: 452.96,
    width: 8.52,
    height: 8.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "154.7 165.49 154.01 169.05 155.39 169.05 154.7 165.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M113.13,331.06H221a2.8,2.8,0,0,0,2.8-2.8V155.45a2.8,2.8,0,0,0-2.8-2.8H113.13a2.81,2.81,0,0,0-2.81,2.8V328.26A2.81,2.81,0,0,0,113.13,331.06ZM211.84,307a2.48,2.48,0,0,1-2.49,2.49H191a2.48,2.48,0,0,1-2.49-2.49v-90.4a2.49,2.49,0,0,1,2.49-2.5h18.35a2.49,2.49,0,0,1,2.49,2.5ZM188.11,164.5c0-2.27,2.18-4.45,5.63-4.45a7.09,7.09,0,0,1,5.34,2.18l-1.88,3a4.37,4.37,0,0,0-2.57-1.08c-.49,0-.79.29-.79.59,0,1,5.34,1,5.34,5.34,0,2.27-2.17,4.45-5.63,4.45-4.35,0-6.13-2.38-6.13-2.38l1.88-3a5.38,5.38,0,0,0,3.36,1.28c.49,0,.79-.29.79-.59C193.45,168.85,188.11,168.85,188.11,164.5Zm-12.55-4.15h10.67v4H180.7v1h5.14v4H180.7v1h5.93v3.95H175.56Zm-12.06,0h5.14v9.29H174v4.55H163.5Zm-12.16,0h6.72c0,.08,4.05,13.84,4.05,13.84h-5.73l-.39-2h-2.57l-.4,2h-5.73Zm-15.72,4.15c0-2.27,2.18-4.45,5.64-4.45a7.09,7.09,0,0,1,5.34,2.18l-1.88,3a4.4,4.4,0,0,0-2.57-1.08c-.5,0-.79.29-.79.59,0,1,5.33,1,5.33,5.34,0,2.27-2.17,4.45-5.63,4.45-4.35,0-6.13-2.38-6.13-2.38l1.88-3a5.38,5.38,0,0,0,3.36,1.28c.5,0,.79-.29.79-.59C141,168.85,135.62,168.85,135.62,164.5Zm-10.86,16.41h84.59a2.5,2.5,0,0,1,0,5H124.76a2.5,2.5,0,0,1,0-5Zm58.38,65V307a2.48,2.48,0,0,1-2.49,2.49H162.3a2.49,2.49,0,0,1-2.5-2.49v-61.1a2.49,2.49,0,0,1,2.5-2.49h18.35A2.48,2.48,0,0,1,183.14,245.86Zm-28.7,10.29V307a2.49,2.49,0,0,1-2.49,2.49H133.6a2.49,2.49,0,0,1-2.5-2.49V256.15a2.5,2.5,0,0,1,2.5-2.5H152A2.5,2.5,0,0,1,154.44,256.15ZM119.78,204a2.49,2.49,0,0,1,5,0V315.79h82.1a2.5,2.5,0,0,1,0,5H122.27a2.49,2.49,0,0,1-2.49-2.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 193.49,
    y: 219.05,
    width: 13.36,
    height: 85.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M662,528.4H443.16v7.79H662ZM460,533a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,0,1-2.5,0V530.9a1.25,1.25,0,0,1,2.5,0Zm4.47,0a1.25,1.25,0,0,1-2.5,0V530.9a1.25,1.25,0,0,1,2.5,0Zm4.46,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm129.79,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,0,1-2.5,0V530.9a1.25,1.25,0,0,1,2.5,0Zm4.47,0a1.25,1.25,0,0,1-2.5,0V530.9a1.25,1.25,0,1,1,2.5,0Zm4.46,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Zm4.47,0a1.25,1.25,0,1,1-2.49,0V530.9a1.25,1.25,0,1,1,2.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M861.54,424.61l-.9,3.81a8.11,8.11,0,0,0,2.68-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M787.63,432.75a4.37,4.37,0,0,0,4.37-4.37V410a4.37,4.37,0,0,0-8.73,0v18.39A4.37,4.37,0,0,0,787.63,432.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M567.53,242.43l9.79-24.89-1.46-.44-9.56,23.55a19.68,19.68,0,0,1,1,1.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "780.46 351.92 780.46 339.02 776.1 339.02 776.1 385.21 780.46 385.21 780.46 351.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 794.8,
    y: 362.05,
    width: 4.36,
    height: 23.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M614.83,351.56v18.9a36.39,36.39,0,0,1-1.7,11H623.8c-3.13-8-4.61-21.77-5.27-31.12A29.12,29.12,0,0,1,614.83,351.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M614.83,331.23a7,7,0,0,0,2.9-2.4c1.29-2,4.53-.15,3.23,1.89a12.28,12.28,0,0,1-6.13,4.56v9.8a20.13,20.13,0,0,0,4.61-2.14l.12-.08a14.53,14.53,0,0,0,5.9-7.16,10.15,10.15,0,0,0-1.39-10.21,5.67,5.67,0,0,0-4-2.34,8.8,8.8,0,0,0-5.2,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M762.38,391.44h-38V536.19h38ZM734,410a9.36,9.36,0,0,1,18.71,0v18.39a9.36,9.36,0,1,1-18.71,0Zm9.36,59.8a2.29,2.29,0,1,1,2.28-2.28A2.28,2.28,0,0,1,743.37,469.79Zm2.28,7.69a2.29,2.29,0,1,1-2.28-2.28A2.28,2.28,0,0,1,745.65,477.48Zm-2.28-17.66a2.29,2.29,0,1,1,2.28-2.29A2.29,2.29,0,0,1,743.37,459.82Zm0-10a2.29,2.29,0,1,1,2.28-2.28A2.28,2.28,0,0,1,743.37,449.84Zm10.28,74.46H733.08a2.5,2.5,0,1,1,0-5h20.57a2.5,2.5,0,1,1,0,5Zm0-7.8H733.08a2.5,2.5,0,1,1,0-5h20.57a2.5,2.5,0,1,1,0,5Zm0-7.79H733.08a2.5,2.5,0,1,1,0-5h20.57a2.5,2.5,0,1,1,0,5Zm0-7.79H733.08a2.5,2.5,0,1,1,0-5h20.57a2.5,2.5,0,1,1,0,5Zm0-7.8H733.08a2.5,2.5,0,1,1,0-5h20.57a2.5,2.5,0,1,1,0,5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "789.82 359.56 789.82 354.41 785.45 354.41 785.45 385.21 789.82 385.21 789.82 359.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "740.87 360.68 740.87 333.88 736.51 333.88 736.51 351.92 736.51 385.21 740.87 385.21 740.87 360.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 745.86,
    y: 363.18,
    width: 4.36,
    height: 22.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "759.58 349.05 755.21 349.05 755.21 360.68 755.21 385.21 759.58 385.21 759.58 349.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M743.37,432.75a4.37,4.37,0,0,0,4.36-4.37V410a4.37,4.37,0,0,0-8.73,0v18.39A4.37,4.37,0,0,0,743.37,432.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 727.15,
    y: 354.41,
    width: 4.36,
    height: 30.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M972.42,426.35a3.13,3.13,0,0,1,1.4,2.64l-.18,16.19,9.51-11.88a3.13,3.13,0,0,1,3.11-1.09,41.79,41.79,0,1,0-13.84-5.86Zm49.66-10.86a32.4,32.4,0,0,1-12.81,9.17,2.66,2.66,0,0,1-.91.17,2.5,2.5,0,0,1-.91-4.82,27.35,27.35,0,0,0,10.83-7.74,2.49,2.49,0,0,1,3.8,3.22Zm-17.66-54.82a2.49,2.49,0,0,1,3-1.88,33,33,0,0,1,23.67,43.31,2.5,2.5,0,0,1-4.7-1.69,28,28,0,0,0-20.08-36.76A2.5,2.5,0,0,1,1004.42,360.67Zm-22.13,22.8c0-8.21,9.71-10.71,9.71-10.71v-4.23h6.47v3.74a18,18,0,0,1,11.45,5.47l-4.73,7.47s-3-2.73-6.47-2.73c-1.25,0-2,.74-2,1.49,0,2.49,13.44,2.49,13.44,13.44,0,9.46-11.7,11-11.7,11v4H992v-4c-8-1-11.46-5.73-11.46-5.73l4.73-7.47a13.57,13.57,0,0,0,8.47,3.24c1.24,0,2-.75,2-1.49C995.73,394.43,982.29,394.43,982.29,383.47ZM963.88,373.2a28.7,28.7,0,0,1,10.17-10.59,2.49,2.49,0,1,1,2.59,4.26,23.71,23.71,0,0,0-8.39,8.75,2.5,2.5,0,0,1-2.19,1.28,2.47,2.47,0,0,1-1.2-.31A2.5,2.5,0,0,1,963.88,373.2Zm-2.4,6.81a2.5,2.5,0,0,1,2.5,2.5v.2a2.5,2.5,0,1,1-5,0v-.2A2.49,2.49,0,0,1,961.48,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M548.61,237.33a12.78,12.78,0,0,0-9.67,5.1h7.19A20.08,20.08,0,0,1,548.61,237.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M893.56,437.77c-.32,0-.64.05-1,.05a11.92,11.92,0,0,1-2.92-.37l-.82,8.65,4,.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M892.19,430.26l-1.67,3.55a8.39,8.39,0,0,0,2.69.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "892.59 450.6 888.51 449.84 888.24 452.6 892.4 453.03 892.59 450.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M548.12,293.36c14.85,13.67,39,25.12,60.47,21v-5.2a3.12,3.12,0,0,1,6.24,0v8.77a13.72,13.72,0,0,1,3.39-.91V299.17c0-.29,0-.58,0-.87a79.45,79.45,0,0,1-36.82-20.24,2.49,2.49,0,1,1,3.47-3.58,74.53,74.53,0,0,0,33,18.6,50.55,50.55,0,0,0-49.68-44.4,24.34,24.34,0,0,0,7.11,12.54,2.51,2.51,0,0,1,.13,3.53,2.53,2.53,0,0,1-1.83.79,2.47,2.47,0,0,1-1.7-.67A29.25,29.25,0,0,1,563.12,249a1.84,1.84,0,0,1,0-.33h-15a19.09,19.09,0,0,0,.27,18.37,2.51,2.51,0,0,1-.87,3.42,2.46,2.46,0,0,1-1.27.35,2.49,2.49,0,0,1-2.15-1.22,23.92,23.92,0,0,1-1.48-20.92h-6.2C527.12,262.18,535.25,281.52,548.12,293.36Zm56,9.55a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,604.12,302.91Zm3.43-23.07a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,607.55,279.84ZM588,259.32a2.5,2.5,0,0,1,2.94,1.95,10.18,10.18,0,0,0,3.66,5.51,35.77,35.77,0,0,0,6.72,4,2.49,2.49,0,1,1-2.25,4.45,38.66,38.66,0,0,1-7.66-4.66,15.08,15.08,0,0,1-5.36-8.35A2.5,2.5,0,0,1,588,259.32Zm-7.76-5.88a1.88,1.88,0,0,1,0,3.75A1.88,1.88,0,0,1,580.22,253.44Zm-9.05,37.07A56.9,56.9,0,0,0,595,300.73a2.49,2.49,0,0,1-.43,4.95,3.28,3.28,0,0,1-.43,0,61.86,61.86,0,0,1-25.91-11.12,2.5,2.5,0,1,1,3-4Zm-4.25-18.05a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,566.92,272.46Zm-5.82,24.73a1.87,1.87,0,0,1,0-3.74A1.87,1.87,0,0,1,561.1,297.19Zm-4.47-42.5a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,556.63,254.69Zm-6.83,19.07a2.51,2.51,0,0,1,3.35,1.11,22,22,0,0,0,6.79,8,2.49,2.49,0,0,1-1.46,4.52,2.46,2.46,0,0,1-1.45-.47,27,27,0,0,1-8.34-9.77A2.5,2.5,0,0,1,549.8,273.76Zm-7.3,5a1.87,1.87,0,0,1,0-3.74A1.87,1.87,0,0,1,542.5,278.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M554.34,238.16a14.57,14.57,0,0,0-2.89,4.27H560A13.19,13.19,0,0,0,554.34,238.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "892.12 456.76 887.89 456.32 886.91 466.67 891.37 466.67 892.12 456.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1021.74,536.19s0-.06,0-.1V533.6H966.88a2.5,2.5,0,0,1,0-5h54.87v-8.73a6.87,6.87,0,0,0-6.86-6.86h-69a6.87,6.87,0,0,0-6.86,6.86v8.73h7.06a2.5,2.5,0,1,1,0,5H939v2.49s0,.07,0,.1Zm-67.12-7.58h2.91a2.5,2.5,0,1,1,0,5h-2.91a2.5,2.5,0,0,1,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M866.31,445.78l-1.87-14.11a12.4,12.4,0,0,1-3.47.51l-.4,0L862.26,447A13.59,13.59,0,0,1,866.31,445.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M866.5,521.54a2.5,2.5,0,1,1,0,5h-7l.62,9.66h35.63l.61-9.66h-7a2.5,2.5,0,0,1,0-5h7.32l3.08-48.63H856.11l3.08,48.63Zm11.43,0h2.5a2.5,2.5,0,0,1,0,5h-2.5a2.5,2.5,0,0,1,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M553,374.93a20.39,20.39,0,0,0-2.87,6.54h56.38a30.07,30.07,0,0,0,2.07-11V319.4a53.59,53.59,0,0,1-9.13.78c-20.31,0-41.19-10.7-54.72-23.15l-.13-.12a75.35,75.35,0,0,1-49.92,25.47v48.08a29.87,29.87,0,0,0,2.08,11h48.36c.27-3.29,2.31-7,3.3-8.62V348.21a2.5,2.5,0,0,1,5,0v25.36A2.55,2.55,0,0,1,553,374.93ZM532.9,344.82a14,14,0,0,1-12.77,8.58,12.44,12.44,0,0,1-1.61-.11,13.92,13.92,0,0,1-11.75-11.84,2.49,2.49,0,1,1,5-.6A8.6,8.6,0,0,0,528.26,343a2.5,2.5,0,1,1,4.64,1.84Zm38.89-3.24A2.5,2.5,0,0,1,575,343a8.6,8.6,0,0,0,16.54-2.13,2.49,2.49,0,1,1,4.95.6,13.93,13.93,0,0,1-11.75,11.84,12.56,12.56,0,0,1-1.61.11,14,14,0,0,1-12.77-8.58A2.5,2.5,0,0,1,571.79,341.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M365.36,169.64a2.38,2.38,0,1,0-2.18-2.37A2.24,2.24,0,0,0,365.36,169.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M863,453.7a12,12,0,0,1,4.17-1.29l-.39-2.93a10.07,10.07,0,0,0-4.09,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M864.5,466.67h4.58l-1.4-10.55a8.39,8.39,0,0,0-4.19,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M85.28,518.32v17.87h55.49V518.32H130.52l-4.23,4.23a3.08,3.08,0,0,1-2.2.92H102a3.1,3.1,0,0,1-2.2-.92l-4.23-4.23Zm36.94,9.51a1.87,1.87,0,0,1,0,3.74A1.87,1.87,0,0,1,122.22,527.83Zm-18.55.16h9.2a1.87,1.87,0,0,1,0,3.74h-9.2A1.87,1.87,0,0,1,103.67,528Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 409.94,
    width: 91.96,
    height: 1.46
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "122.8 517.23 126.38 513.65 99.66 513.65 103.25 517.23 122.8 517.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 74.05,
    y: 518.32,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 62.83,
    y: 518.32,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 158.22,
    y: 470.16,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 454,
    width: 91.96,
    height: 1.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 158.22,
    y: 518.32,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M674.57,289.92H934.83a14.66,14.66,0,0,0,14.65-14.65V155.45a14.66,14.66,0,0,0-14.65-14.65H674.57a14.66,14.66,0,0,0-14.65,14.65V275.27A14.66,14.66,0,0,0,674.57,289.92Zm-8.41-134.47a8.42,8.42,0,0,1,8.41-8.41H934.83a8.42,8.42,0,0,1,8.42,8.41V275.27a8.42,8.42,0,0,1-8.42,8.41H674.57a8.42,8.42,0,0,1-8.41-8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M95.52,422H85.28v17.88h55.49V422H130.52l-4.23,4.23a3.08,3.08,0,0,1-2.2.92H102a3.1,3.1,0,0,1-2.2-.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147,
    y: 518.32,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "125.86 417.84 100.18 417.84 101.64 419.29 124.41 419.29 125.86 417.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147,
    y: 421.99,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 413.89,
    width: 91.96,
    height: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M806.65,391.44h-38V536.19h38ZM778.28,410a9.35,9.35,0,0,1,18.7,0v18.39a9.35,9.35,0,1,1-18.7,0Zm9.35,59.8a2.29,2.29,0,1,1,2.29-2.28A2.28,2.28,0,0,1,787.63,469.79Zm2.29,7.69a2.29,2.29,0,1,1-2.29-2.28A2.28,2.28,0,0,1,789.92,477.48Zm-2.29-17.66a2.29,2.29,0,1,1,2.29-2.29A2.29,2.29,0,0,1,787.63,459.82Zm0-10a2.29,2.29,0,1,1,2.29-2.28A2.28,2.28,0,0,1,787.63,449.84Zm10.29,74.46H777.34a2.5,2.5,0,0,1,0-5h20.58a2.5,2.5,0,0,1,0,5Zm0-7.8H777.34a2.5,2.5,0,0,1,0-5h20.58a2.5,2.5,0,0,1,0,5Zm0-7.79H777.34a2.5,2.5,0,0,1,0-5h20.58a2.5,2.5,0,0,1,0,5Zm0-7.79H777.34a2.5,2.5,0,0,1,0-5h20.58a2.5,2.5,0,0,1,0,5Zm0-7.8H777.34a2.5,2.5,0,0,1,0-5h20.58a2.5,2.5,0,0,1,0,5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 458.14,
    width: 91.96,
    height: 2.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 405.99,
    width: 91.96,
    height: 1.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 169.45,
    y: 421.99,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 402.04,
    width: 91.96,
    height: 1.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M66.88,463.92H96.81a3.08,3.08,0,0,1,2.2.92l.49.49h27l.49-.49a3.1,3.1,0,0,1,2.2-.92h29.62v-1h-92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 398.09,
    width: 91.96,
    height: 1.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 394.14,
    width: 91.96,
    height: 1.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 158.22,
    y: 421.99,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 169.45,
    y: 470.16,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "124.04 467.82 102 467.82 103.25 469.07 122.8 469.07 124.04 467.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 147,
    y: 470.16,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M99.75,474.39l-4.23-4.23H85.28V488h55.49V470.16H130.52l-4.23,4.23a3.11,3.11,0,0,1-2.2.91H102A3.13,3.13,0,0,1,99.75,474.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 74.05,
    y: 470.16,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 62.83,
    y: 470.16,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 389.95,
    width: 91.96,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 392.85,
    y: 219.05,
    width: 13.36,
    height: 85.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M240.32,481.85a2.49,2.49,0,1,1,5,0v4.21h15.44V447.4a17.93,17.93,0,0,0-35.85,0v38.66h15.43Zm11.43-36.79a2.49,2.49,0,1,1,5,0v2.7a2.49,2.49,0,1,1-5,0Zm0,14.21a2.49,2.49,0,0,1,5,0V462a2.49,2.49,0,1,1-5,0Zm0,14.21a2.49,2.49,0,0,1,5,0v2.7a2.49,2.49,0,1,1-5,0Zm-11.43-39.43a2.49,2.49,0,1,1,5,0v4.57a2.49,2.49,0,0,1-5,0Zm0,16.42a2.49,2.49,0,1,1,5,0V455a2.49,2.49,0,1,1-5,0Zm0,16.57a2.49,2.49,0,0,1,5,0v3.59a2.49,2.49,0,0,1-5,0Zm-6.45,9.14a2.49,2.49,0,1,1-5,0v-2.7a2.49,2.49,0,0,1,5,0Zm0-14.21a2.49,2.49,0,1,1-5,0v-2.7a2.49,2.49,0,0,1,5,0Zm0-14.21a2.49,2.49,0,1,1-5,0v-2.7a2.49,2.49,0,0,1,5,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 697.75,
    y: 215.2,
    width: 43.12,
    height: 45.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 213.3,
    y: 492.29,
    width: 59.02,
    height: 7.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M674.57,277.45H934.83a2.19,2.19,0,0,0,2.18-2.18V155.45a2.19,2.19,0,0,0-2.18-2.18H674.57a2.19,2.19,0,0,0-2.18,2.18V275.27A2.19,2.19,0,0,0,674.57,277.45Zm152.07-94.21a2.72,2.72,0,0,1,.34-.42l.08-.06a50.1,50.1,0,0,1,79.09,3.66l0,0a3.19,3.19,0,0,1,.31.44,50.07,50.07,0,0,1,7.74,39l0,.14a50.17,50.17,0,0,1-68.81,35.4l-.15-.06-.08,0a50.15,50.15,0,0,1-18.52-78.13Zm-41.5-15.58a2.5,2.5,0,1,1,5,0v95.4a2.5,2.5,0,1,1-5,0Zm-89.89-2.5h46.14a2.5,2.5,0,1,1,0,5H695.25a2.5,2.5,0,0,1,0-5Zm0,10.14h16.21a2.5,2.5,0,1,1,0,5H695.25a2.5,2.5,0,0,1,0-5Zm0,10.14h29.41a2.5,2.5,0,0,1,0,5H695.25a2.5,2.5,0,0,1,0-5Zm0,10.13h41.57a2.5,2.5,0,0,1,0,5H695.25a2.5,2.5,0,0,1,0-5Zm-2.49,17.14a2.49,2.49,0,0,1,2.49-2.49h48.12a2.49,2.49,0,0,1,2.49,2.49v50.35a2.5,2.5,0,0,1-2.49,2.5H695.25a2.5,2.5,0,0,1-2.49-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M249.46,526.32h15.21l3-20H218l3,20h8.77a1.87,1.87,0,1,1,0,3.74h-8.21l.92,6.13h40.76l.92-6.13H249.46a1.87,1.87,0,1,1,0-3.74Zm-8.31,3.74H238a1.87,1.87,0,1,1,0-3.74h3.12a1.87,1.87,0,1,1,0,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M900.91,187.72a45.11,45.11,0,0,0-68.76-3.18l33.17,33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M849.82,257.86a45.19,45.19,0,0,0,58.85-30.23l-42-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1096.66,542.43H13.09a6.86,6.86,0,0,0-6.86,6.85v2.81H88.81a3.12,3.12,0,1,1,0,6.24H6.23v12.16a6.86,6.86,0,0,0,6.86,6.85H1096.66a6.85,6.85,0,0,0,6.85-6.85V558.33h-97.76a3.12,3.12,0,0,1,0-6.24h97.76v-2.81A6.85,6.85,0,0,0,1096.66,542.43Zm-961.3,15.9H117.91a3.12,3.12,0,1,1,0-6.24h17.45a3.12,3.12,0,0,1,0,6.24Zm54.87,0H165.29a3.12,3.12,0,1,1,0-6.24h24.94a3.12,3.12,0,1,1,0,6.24Zm197.85,0H213.51a3.12,3.12,0,1,1,0-6.24H388.08a3.12,3.12,0,1,1,0,6.24Zm60.69,0H425.49a3.12,3.12,0,0,1,0-6.24h23.28a3.12,3.12,0,0,1,0,6.24Zm41.56,0h-10.8a3.12,3.12,0,1,1,0-6.24h10.8a3.12,3.12,0,0,1,0,6.24Zm237.76,0h-207a3.12,3.12,0,0,1,0-6.24h207a3.12,3.12,0,1,1,0,6.24Zm49,0H753a3.12,3.12,0,0,1,0-6.24h24.11a3.12,3.12,0,0,1,0,6.24Zm182.05,0H814.55a3.12,3.12,0,0,1,0-6.24H959.19a3.12,3.12,0,0,1,0,6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M909.77,222.71a45.69,45.69,0,0,0,.6-7.36,45,45,0,0,0-6.61-23.51l-32.41,28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 169.45,
    y: 518.32,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M34.29,618.93a11.33,11.33,0,0,0,11.32,11.31H1064.15a11.33,11.33,0,0,0,11.31-11.31V583.58H34.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 49.08,
    y: 421.99,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 74.05,
    y: 421.99,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 62.83,
    y: 421.99,
    width: 4.99,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 49.08,
    y: 518.32,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 49.08,
    y: 470.16,
    width: 7.51,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.88,
    y: 508.66,
    width: 91.96,
    height: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 936.36,
    y: 528.61,
    width: 88.4,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 49.08,
    y: 421.99,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 49.08,
    y: 470.16,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 49.08,
    y: 518.32,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 173.2,
    y: 421.99,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 173.2,
    y: 470.16,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 173.2,
    y: 518.32,
    width: 3.76,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 147,
    y: 385.52,
    width: 13.72,
    height: 32.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 147,
    y: 451.92,
    width: 13.72,
    height: 16.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 147,
    y: 505.57,
    width: 13.72,
    height: 9.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M231.09,433.86s-3.32,5.72-3.32,11.08v44.34h-5.64V442.57s4.21-8.88,9-10.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M254.53,433.86s3.32,5.72,3.32,11.08v44.34h5.64V442.57s-4.21-8.88-9-10.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 213.3,
    y: 492.29,
    width: 2.83,
    height: 10.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "220.89 506.29 224.88 538.66 220.89 538.66 216.12 504"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "262.16 505.57 256.74 538.66 265.74 537.44 270.69 504 262.16 505.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 267.66,
    y: 490.42,
    width: 7.97,
    height: 12.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 383.48,
    y: 429.48,
    width: 12.1,
    height: 92.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 308.1,
    y: 522.17,
    width: 4.95,
    height: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 398.89,
    y: 522.17,
    width: 6.05,
    height: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 328.54,
    y: 451.91,
    width: 1.66,
    height: 11.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 354.71,
    cy: 454.93,
    r: 3.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M374,454.93a4,4,0,1,1-4-4A4,4,0,0,1,374,454.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.09,
    y: 258.64,
    width: 2.68,
    height: 47.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 164.79,
    y: 248.35,
    width: 2.68,
    height: 58.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 193.49,
    y: 219.05,
    width: 2.68,
    height: 85.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 335.45,
    y: 258.64,
    width: 2.68,
    height: 47.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 364.15,
    y: 248.35,
    width: 2.68,
    height: 58.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 392.85,
    y: 219.05,
    width: 2.68,
    height: 85.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 137.43,
    y: 196.61,
    width: 38.13,
    height: 13.21,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 331.68,
    y: 196.61,
    width: 38.13,
    height: 13.21,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100.94,326.54V157.18c0-14.17,14.31-16.38,14.31-16.38l1.28-3.43c-22-.18-22,14.49-22,14.49v180s0,14.68,22,14.49l-1.28-3.43S100.94,340.71,100.94,326.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M297.66,326.54V157.18C297.66,143,312,140.8,312,140.8l1.28-3.43c-22-.18-22,14.49-22,14.49v180s0,14.68,22,14.49L312,342.92S297.66,340.71,297.66,326.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M663,278.13V152.62c0-10.5,15.41-12.14,15.41-12.14l1.28-2.54c-22-.14-22,10.74-22,10.74V282.07s0,10.87,22,10.74l-1.28-2.55S663,288.63,663,278.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 724.35,
    y: 391.44,
    width: 2.49,
    height: 146.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 768.62,
    y: 391.44,
    width: 2.49,
    height: 146.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 801.65,
    y: 391.44,
    width: 4.99,
    height: 146.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 727.15,
    y: 354.41,
    width: 1.41,
    height: 32.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 745.86,
    y: 363.18,
    width: 1.41,
    height: 24.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 755.21,
    y: 347.92,
    width: 1.41,
    height: 39.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 776.1,
    y: 337.24,
    width: 1.41,
    height: 50.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 785.45,
    y: 351.27,
    width: 1.41,
    height: 36.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 794.8,
    y: 362.11,
    width: 1.41,
    height: 25.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 736.51,
    y: 333.87,
    width: 1.41,
    height: 52.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 856.11,
    y: 524.61,
    width: 42.65,
    height: 13.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "853.09 475.2 903.71 475.2 903.71 469.79 854.38 469.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M962.31,396.25c2.83,0,2.84-4.4,0-4.4s-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M964.75,404.81a20.68,20.68,0,0,0,11.55,10.63c2.65,1,3.79-3.23,1.17-4.24a16.36,16.36,0,0,1-8.92-8.61c-1.18-2.57-5-.33-3.8,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M990.37,363c2.83,0,2.84-4.4,0-4.4s-2.83,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1020.91,393.22c2.83,0,2.84-4.4,0-4.4s-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M990.1,425.69c2.83,0,2.83-4.41,0-4.41s-2.84,4.41,0,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M941.32,536.27c-1-8.27-2-19.08,7.26-23,2.6-1.11.36-4.9-2.22-3.8-10.69,4.6-10.61,17-9.44,26.84.33,2.78,4.73,2.82,4.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M952.86,506.86A24,24,0,0,1,962.2,483c2.24-1.68,0-5.5-2.22-3.8A28.62,28.62,0,0,0,948.62,508c.49,2.79,4.73,1.61,4.24-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M187.05,204.5h8c2.83,0,2.84-4.4,0-4.4h-8c-2.83,0-2.83,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M208.24,205.05c2.83,0,2.83-4.4,0-4.4s-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M138.91,235.49h10.27c2.83,0,2.84-4.4,0-4.4H138.91c-2.83,0-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M162.39,235.13c2.83,0,2.83-4.41,0-4.41s-2.84,4.41,0,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M339.19,241c2.83,0,2.84-4.41,0-4.41s-2.84,4.41,0,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M349.83,241.36h3.66a2.2,2.2,0,1,0,0-4.4h-3.66a2.2,2.2,0,1,0,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M366.7,231.46c2.83,0,2.84-4.4,0-4.4s-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M389.81,205.78h10.64c2.83,0,2.83-4.4,0-4.4H389.81c-2.83,0-2.84,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M410,205.78c2.84,0,2.84-4.4,0-4.4s-2.83,4.4,0,4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 697.75,
    y: 215.2,
    width: 4.4,
    height: 46.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 728.97,
    y: 248.66,
    width: 11.9,
    height: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M826.74,199.47A24.14,24.14,0,0,0,825.25,213c.35,2.09,3.53,1.2,3.18-.88a21.06,21.06,0,0,1,1.49-11.78c.82-2-2.37-2.81-3.18-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M829.07,223.94a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M833.29,232a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M870.22,255.44A44.14,44.14,0,0,0,893,245c1.61-1.39-.73-3.71-2.33-2.33a41.19,41.19,0,0,1-21.31,9.64c-2.1.3-1.21,3.48.87,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M897.66,238.43a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M901.3,206.73a8.9,8.9,0,0,1,2.39,5.29c.19,2.1,3.49,2.12,3.3,0a12.75,12.75,0,0,0-3.35-7.63c-1.45-1.56-3.78.78-2.34,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M849.58,184.57a39.81,39.81,0,0,1,24.19-1.67c2.06.5,2.94-2.69.88-3.19a43,43,0,0,0-25.95,1.68c-2,.76-1.11,4,.88,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M884.27,186.34a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M865.2,210a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M868.87,233.48a1.66,1.66,0,0,0,0-3.31,1.66,1.66,0,0,0,0,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M883.72,217.7a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M853.09,223.39a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M804.67,173.69h8.62a1.66,1.66,0,0,0,0-3.31h-8.62a1.66,1.66,0,0,0,0,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M820.63,173.5a1.65,1.65,0,0,0,0-3.3,1.65,1.65,0,0,0,0,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M448.62,387.7v151h-8.5V392.38A9.89,9.89,0,0,1,448.62,387.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 470.75,
    y: 518.95,
    width: 28.99,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 605.42,
    y: 518.95,
    width: 28.99,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 757.39,
    y: 391.44,
    width: 4.99,
    height: 146.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1096.66,536.19H1028s0-.06,0-.1V524.75a13.26,13.26,0,0,0,8.63-21.29,10.6,10.6,0,0,0-3-2.65,11.83,11.83,0,0,0-9.32-8.81,10.63,10.63,0,0,0-4.41-5.79,13.58,13.58,0,0,0-8.76-1.91,9.67,9.67,0,0,0-4.5-4.1c-3.49-1.54-8-1.13-12,1.07a30.37,30.37,0,0,0-6.69,5.36,19.84,19.84,0,0,0-16.43-8.73h-8.73A19.87,19.87,0,0,0,943,497.75v9.38a13.1,13.1,0,0,0-10.18,12.75v16.21s0,.07,0,.1H902l4.19-66.2a3.13,3.13,0,0,0-3.11-3.32h-6.71l2.34-30.82a2.38,2.38,0,0,0-.08-.84l-3.39-12.6a2.49,2.49,0,0,0-4.66-.42l-5.38,11.4a2.63,2.63,0,0,0-.23.83l-3.07,32.45h-7.79l-5-37.94a2.62,2.62,0,0,0-.25-.81l-5.92-11.63a2.5,2.5,0,0,0-4.65.55l-2.91,12.27a2.26,2.26,0,0,0-.05.86l4.18,36.7h-6.69a3.11,3.11,0,0,0-3.11,3.32l4.19,66.2h-41V388.33a3.11,3.11,0,0,0-3.11-3.12h-5.62V359.56a2.48,2.48,0,0,0-2.49-2.49H794.8v-5.15a2.49,2.49,0,0,0-2.49-2.5h-6.86v-12.9A2.5,2.5,0,0,0,783,334H773.6a2.5,2.5,0,0,0-2.49,2.49v48.69h-6.55V346.55a2.48,2.48,0,0,0-2.49-2.49h-9.35a2.49,2.49,0,0,0-2.5,2.49v11.64h-4.36V331.38a2.49,2.49,0,0,0-2.49-2.49H734a2.49,2.49,0,0,0-2.49,2.49v18h-6.86a2.49,2.49,0,0,0-2.49,2.5v33.29h-.94a3.12,3.12,0,0,0-3.12,3.12V536.19H668.24V395.81a14.36,14.36,0,0,0-14.35-14.34H630.52c-2.36-3.22-5-18.24-6-34.57a20.36,20.36,0,0,0,6.76-9,16.32,16.32,0,0,0-2.46-16.37,13.25,13.25,0,0,0-4.39-3.48V299.17a56.8,56.8,0,0,0-51.66-56.5L583,216.84a2.53,2.53,0,0,0-.08-2,2.5,2.5,0,0,0-1.53-1.3l-6.23-1.87a2.5,2.5,0,0,0-3,1.45l-9.36,23.07a18.7,18.7,0,0,0-13.27-5.14,19.35,19.35,0,0,0-17.86,11.53,56.81,56.81,0,0,0-52.77,56.59V318a13.15,13.15,0,0,0-4.39,3.48A16.34,16.34,0,0,0,472,337.85a20.39,20.39,0,0,0,6.77,9c-1,16.37-3.62,31.42-6,34.57H451.26a14.35,14.35,0,0,0-14.34,14.34V536.19H410.11v-14a3.11,3.11,0,0,0-3.12-3.11h-7.07V428.54a3.12,3.12,0,0,0-3.11-3.12h-8.05v-3.79a3.59,3.59,0,1,0-7.17,0v3.79h-7v-3.79a3.59,3.59,0,1,0-7.17,0v3.79h-7v-3.79a3.59,3.59,0,1,0-7.17,0v3.79h-7v-3.79a3.59,3.59,0,1,0-7.17,0v3.79h-7v-3.79a3.59,3.59,0,1,0-7.17,0v3.79H316.8a3.12,3.12,0,0,0-3.12,3.12v90.51h-7.07a3.11,3.11,0,0,0-3.11,3.11v14h-34l4.47-29.9h1.47a3.12,3.12,0,0,0,3.12-3.11v-14a3.12,3.12,0,0,0-3.12-3.11H267V481l1.93-.43a2.49,2.49,0,1,0-1.06-4.87l-.87.19V469l1.22.42a2.56,2.56,0,0,0,.81.14,2.5,2.5,0,0,0,.8-4.86l-2.83-1v-6.2h2.86a2.5,2.5,0,0,0,0-5H267V447.4c0-.4,0-.8-.06-1.19l1.87-1a2.5,2.5,0,1,0-2.45-4.35l-.26.15a24.4,24.4,0,0,0-1.72-4.45l1.7-1.25a2.49,2.49,0,1,0-2.95-4l-1.45,1.07a24.11,24.11,0,0,0-4.72-4.47l1.14-1.4a2.49,2.49,0,1,0-3.86-3.15L252.79,425a2,2,0,0,0-.2.3,23.81,23.81,0,0,0-7.3-2c0-.05,0-.09,0-.13v-1.87a2.49,2.49,0,0,0-5,0v1.87s0,.08,0,.13a23.81,23.81,0,0,0-7.3,2,2,2,0,0,0-.2-.3l-1.42-1.74a2.49,2.49,0,1,0-3.86,3.15l1.14,1.4a24.4,24.4,0,0,0-4.72,4.47l-1.45-1.07a2.49,2.49,0,1,0-3,4l1.7,1.25a24.4,24.4,0,0,0-1.72,4.45l-.26-.15a2.49,2.49,0,1,0-2.44,4.35l1.86,1c0,.39-.06.79-.06,1.19v5.12h-2.86a2.5,2.5,0,0,0,0,5h2.86v6.2l-2.83,1a2.5,2.5,0,0,0,.8,4.86,2.56,2.56,0,0,0,.81-.14l1.22-.42v6.88l-.87-.19a2.49,2.49,0,1,0-1.06,4.87l1.93.43v5.09h-8.47a3.12,3.12,0,0,0-3.12,3.11v14a3.12,3.12,0,0,0,3.12,3.11h1.47l4.47,29.9H183.2v-21a3.12,3.12,0,0,0-3.12-3.11h-3.15V494.27h3.15a3.12,3.12,0,0,0,3.12-3.12V467a3.12,3.12,0,0,0-3.12-3.12h-3.15V446.1h3.15A3.12,3.12,0,0,0,183.2,443v-24.1a3.12,3.12,0,0,0-3.12-3.12H163.84V387.45a2.5,2.5,0,0,0-2.5-2.49H64.39a2.49,2.49,0,0,0-2.49,2.49v28.31H46a3.11,3.11,0,0,0-3.11,3.12V443A3.11,3.11,0,0,0,46,446.1h3.15v17.82H46A3.12,3.12,0,0,0,42.85,467v24.11A3.12,3.12,0,0,0,46,494.27h3.15v17.82H46a3.11,3.11,0,0,0-3.11,3.11v21H13.09A13.1,13.1,0,0,0,0,549.28v21.21a13.1,13.1,0,0,0,13.09,13.09h15v35.35a17.57,17.57,0,0,0,17.56,17.54H1064.15a17.56,17.56,0,0,0,17.54-17.54V583.58h15a13.1,13.1,0,0,0,13.09-13.09V549.28A13.1,13.1,0,0,0,1096.66,536.19Zm-66.42-32.67a3.76,3.76,0,0,1-.51,2.06,1.51,1.51,0,0,1-1.44.71c-.27-.07-.43-.39-.49-.53a1.45,1.45,0,0,1,0-1.19,2.44,2.44,0,0,1,2.14-1.07Zm-21.66-14.89a4,4,0,0,1-.26,1.35,2.52,2.52,0,0,1-1.53,1.58,1.09,1.09,0,0,1-1.16-.4,1.37,1.37,0,0,1,.4-1.21,5.47,5.47,0,0,1,2.17-1.2Zm-12.09-4.08c3-1.65,6.22-2,8.64-.93a5.77,5.77,0,0,1,2,1.53l-.18.06a8.81,8.81,0,0,0-3.7,2.21,5,5,0,0,0-1.12,5.12,4.73,4.73,0,0,0,5.58,2.64,6.19,6.19,0,0,0,4.07-3.83,7.47,7.47,0,0,0,.47-3.37,9.7,9.7,0,0,1,5.6,1.38,6.87,6.87,0,0,1,2.34,2.57,10.18,10.18,0,0,0-1.22.26,7.41,7.41,0,0,0-4.06,2.48,5,5,0,0,0-.56,5.51,4.89,4.89,0,0,0,5.52,2.07,6.58,6.58,0,0,0,4-3.46,8.33,8.33,0,0,0,.84-2.83,7.89,7.89,0,0,1,2,1,8.16,8.16,0,0,1,2.51,2.81,6,6,0,0,0-4.75,3,5.19,5.19,0,0,0-.15,4.41,4.59,4.59,0,0,0,2.9,2.67,5.16,5.16,0,0,0,5.57-2.21,6.79,6.79,0,0,0,.87-1.89,9.5,9.5,0,0,1-5.7,15.15v-1.06a13.11,13.11,0,0,0-13.1-13.09h-2.69a2.58,2.58,0,0,0,0-.39,3.51,3.51,0,0,0-3.5-3.51h-9.36a3.51,3.51,0,0,0-3.5,3.51,2.58,2.58,0,0,0,0,.39h-4.51v-9a19.69,19.69,0,0,0-1.55-7.68A29.38,29.38,0,0,1,996.49,484.55ZM1021,495.6a4.43,4.43,0,0,1-.44,1.49,3,3,0,0,1-1.65,1.56,1.21,1.21,0,0,1-1.27-.35,1.32,1.32,0,0,1,.25-1.32,4.16,4.16,0,0,1,2.1-1.18A6.94,6.94,0,0,1,1021,495.6Zm-71.76,2.15a13.63,13.63,0,0,1,13.61-13.62h8.73a13.63,13.63,0,0,1,13.61,13.62v2.59H949.22Zm0,6.34h35.95v2.7H949.22ZM939,533.6h7.06a2.5,2.5,0,1,0,0-5H939v-8.73A6.87,6.87,0,0,1,945.9,513h69a6.87,6.87,0,0,1,6.86,6.86v8.73H966.88a2.5,2.5,0,0,0,0,5h54.87v2.49s0,.07,0,.1H939.05s0-.06,0-.1ZM892.19,430.26l1,3.79a8.39,8.39,0,0,1-2.69-.24Zm-2.51,7.19a11.92,11.92,0,0,0,2.92.37c.32,0,.64,0,1-.05l-.69,9.07-4-.74Zm-1.17,12.39,4.08.76-.18,2.43-4.17-.43Zm-.62,6.48,4.23.44-.75,9.91h-4.46Zm-18.81,10.35H864.5l-1-8.83a8.39,8.39,0,0,1,4.19-1.72Zm-1.89-14.26A12,12,0,0,0,863,453.7l-.31-2.72a10.07,10.07,0,0,1,4.09-1.5Zm-5.65-27.8,1.78,3.49a8.11,8.11,0,0,1-2.68.32Zm-.57,7.57a12.4,12.4,0,0,0,3.47-.51l1.87,14.11a13.59,13.59,0,0,0-4,1.19l-1.69-14.81Zm38.79,40.73-3.08,48.63h-7.32a2.5,2.5,0,0,0,0,5h7l-.61,9.66H860.12l-.62-9.66h7a2.5,2.5,0,1,0,0-5h-7.31l-3.08-48.63Zm-105-110.86h4.37v23.16H794.8Zm-9.35-7.64h4.36v30.8h-4.36ZM776.1,339h4.36v46.19H776.1Zm-7.48,52.42h38V536.19h-38Zm-13.41-30.76V349.05h4.37v36.16h-4.37Zm-9.35,2.5h4.36v22h-4.36Zm-9.35-11.26V333.87h4.36v51.34h-4.36Zm-9.36,2.49h4.37v30.8h-4.37Zm-2.8,37h38V536.19h-38ZM624.07,325.49a10.15,10.15,0,0,1,1.39,10.21,14.53,14.53,0,0,1-5.9,7.16l-.12.08a20.13,20.13,0,0,1-4.61,2.14v-9.8a12.28,12.28,0,0,0,6.13-4.56c1.3-2-1.94-3.91-3.23-1.89a7,7,0,0,1-2.9,2.4V325a8.8,8.8,0,0,1,5.2-1.83A5.67,5.67,0,0,1,624.07,325.49Zm-.27,56H613.13a36.39,36.39,0,0,0,1.7-11v-18.9a29.12,29.12,0,0,0,3.7-1.21C619.19,359.7,620.67,373.5,623.8,381.47ZM575.86,217.1l1.46.44-9.79,24.89h-.28a19.68,19.68,0,0,0-1-1.78Zm-21.52,21.06a13.19,13.19,0,0,1,5.65,4.27h-8.54A14.57,14.57,0,0,1,554.34,238.16Zm-5.73-.83a20.08,20.08,0,0,0-2.48,5.1h-7.19A12.78,12.78,0,0,1,548.61,237.33Zm-12.25,11.33h6.2A23.92,23.92,0,0,0,544,269.58a2.49,2.49,0,0,0,2.15,1.22,2.46,2.46,0,0,0,1.27-.35,2.51,2.51,0,0,0,.87-3.42,19.09,19.09,0,0,1-.27-18.37h15a1.84,1.84,0,0,0,0,.33,29.25,29.25,0,0,0,8.75,15.88,2.47,2.47,0,0,0,1.7.67,2.53,2.53,0,0,0,1.83-.79,2.51,2.51,0,0,0-.13-3.53,24.34,24.34,0,0,1-7.11-12.54,50.55,50.55,0,0,1,49.68,44.4,74.53,74.53,0,0,1-33-18.6,2.49,2.49,0,1,0-3.47,3.58A79.45,79.45,0,0,0,618.2,298.3c0,.29,0,.58,0,.87V317a13.72,13.72,0,0,0-3.39.91v-8.77a3.12,3.12,0,0,0-6.24,0v5.2c-21.49,4.14-45.62-7.31-60.47-21C535.25,281.52,527.12,262.18,536.36,248.66Zm14.56,97.06a2.49,2.49,0,0,0-2.49,2.49v24.64c-1,1.63-3,5.33-3.3,8.62H496.77a29.87,29.87,0,0,1-2.08-11V322.38a75.35,75.35,0,0,0,49.92-25.47l.13.12c13.53,12.45,34.41,23.15,54.72,23.15a53.59,53.59,0,0,0,9.13-.78v51.06a30.07,30.07,0,0,1-2.07,11H550.14a20.39,20.39,0,0,1,2.87-6.54,2.55,2.55,0,0,0,.41-1.36V348.21A2.5,2.5,0,0,0,550.92,345.72Zm-65.86-46.55a50.77,50.77,0,0,1,1.11-10.53A55,55,0,0,0,496.73,300a2.49,2.49,0,0,0,3.13-3.88A50.19,50.19,0,0,1,488,282.22a50.72,50.72,0,0,1,22.82-27.05,26.16,26.16,0,0,0,.47,19.41,2.5,2.5,0,0,0,4.58-2,21.35,21.35,0,0,1,.73-18.16,6.62,6.62,0,0,1,2.57-3l.09-.06a49.77,49.77,0,0,1,11.16-2.45c-7.13,14.06-.69,31.92,10.67,44.42-1.35,1.55-2.74,3-4.15,4.37a42.39,42.39,0,0,1-17.1-15.55,2.49,2.49,0,1,0-4.24,2.62A47.39,47.39,0,0,0,533,301.29a71,71,0,0,1-15.91,10l-.18-.1a46,46,0,0,1-9.69-6,2.5,2.5,0,1,0-3.13,3.89,51.52,51.52,0,0,0,6.89,4.63,69.18,69.18,0,0,1-16.25,3.63v-8.2a3.12,3.12,0,0,0-6.23,0v8.76a13.68,13.68,0,0,0-3.4-.9Zm5.1,82.3H479.49c3.13-8,4.6-21.77,5.27-31.12a28.61,28.61,0,0,0,3.7,1.21v18.9A36.39,36.39,0,0,0,490.16,381.47ZM477.82,335.7a10.2,10.2,0,0,1,1.39-10.21,5.71,5.71,0,0,1,4-2.34,8.9,8.9,0,0,1,5.21,1.83v6.25a7,7,0,0,1-2.9-2.4c-1.29-2-4.53-.15-3.23,1.89a12.24,12.24,0,0,0,6.13,4.56v9.8a19.81,19.81,0,0,1-4.62-2.15l-.1-.07A14.58,14.58,0,0,1,477.82,335.7Zm-34.66,60.11a8.11,8.11,0,0,1,8.1-8.11H653.89a8.12,8.12,0,0,1,8.11,8.11V522.17H639.4v-5.72a2.49,2.49,0,0,0-2.5-2.49h-34a2.49,2.49,0,0,0-2.49,2.49v5.72h-95.7v-5.72a2.49,2.49,0,0,0-2.5-2.49h-34a2.48,2.48,0,0,0-2.49,2.49v5.72h-22.6ZM634.41,519v3.22h-29V519Zm-134.67,0v3.22h-29V519Zm-56.58,9.45H662v7.79H443.16ZM319.92,431.66h4.93v3.27a3.59,3.59,0,1,0,7.17,0v-3.27h7v3.27a3.59,3.59,0,1,0,7.17,0v-3.27h7v3.27a3.59,3.59,0,1,0,7.17,0v-3.27h7v3.27a3.59,3.59,0,1,0,7.17,0v-3.27h7v3.27a3.59,3.59,0,1,0,7.17,0v-3.27h4.93v87.39H319.92Zm-10.19,99.86H344a1.87,1.87,0,0,0,0-3.74H309.73v-2.5h94.15v2.5H364.81a1.87,1.87,0,1,0,0,3.74h39.07v4.67H309.73ZM224.89,447.4a17.93,17.93,0,0,1,35.85,0v38.66H245.3v-4.21a2.49,2.49,0,1,0-5,0v4.21H224.89ZM213.3,500.06v-7.77h59v7.77Zm36.16,30h14.65l-.92,6.13H222.43l-.92-6.13h8.21a1.87,1.87,0,1,0,0-3.74H221l-3-20h49.7l-3,20H249.46a1.87,1.87,0,1,0,0,3.74ZM177,518.32v17.87h-7.51V518.32Zm-15.62-14.65H64.39a2.49,2.49,0,0,0-2.49,2.49v5.93H55.35V494.27H170.69v17.82h-6.85v-5.93A2.5,2.5,0,0,0,161.34,503.67Zm-94.46,7.48v-2.49h92v2.49ZM152,518.32v17.87h-5V518.32Zm-52.24,4.23a3.1,3.1,0,0,0,2.2.92h22.14a3.08,3.08,0,0,0,2.2-.92l4.23-4.23h10.25v17.87H85.28V518.32H95.52Zm-.09-8.9h26.72l-3.58,3.58H103.25ZM79,518.32v17.87h-5V518.32Zm-11.22,0v17.87h-5V518.32Zm90.4,0h5v17.87h-5Zm.63-62.67h-92V454h92Zm4.36,14.51V488h-5V470.16Zm-4.36-12v2.26h-92v-2.26Zm0,4.76v1H129.23a3.1,3.1,0,0,0-2.2.92l-.49.49h-27l-.49-.49a3.08,3.08,0,0,0-2.2-.92H66.88v-1ZM152,470.16V488h-5V470.16Zm-27.9,5.14a3.11,3.11,0,0,0,2.2-.91l4.23-4.23h10.25V488H85.28V470.16H95.52l4.23,4.23a3.13,3.13,0,0,0,2.2.91ZM102,467.82h22l-1.24,1.25H103.25Zm-23,2.34V488h-5V470.16Zm-11.22,0V488h-5V470.16Zm109.14,0V488h-7.51V470.16ZM169.45,422H177v17.88h-7.51Zm-6.24,0v17.88h-5V422ZM66.88,390h92v1.7h-92Zm0,4.19h92v1.46h-92Zm0,3.95h92v1.46h-92Zm0,4h92v1.46h-92Zm0,3.95h92v1.46h-92Zm0,3.95h92v1.45h-92Zm0,3.95h92v1.45h-92ZM152,422v17.88h-5V422Zm-50,5.15h22.14a3.08,3.08,0,0,0,2.2-.92l4.23-4.23h10.25v17.88H85.28V422H95.52l4.23,4.23A3.1,3.1,0,0,0,102,427.14Zm-1.77-9.3h25.68l-1.45,1.45H101.63ZM79,422v17.88h-5V422Zm-16.21,0h5v17.88h-5ZM170.69,446.1v17.82h-6.85V451.51a2.5,2.5,0,0,0-2.5-2.5H64.39a2.49,2.49,0,0,0-2.49,2.5v12.41H55.35V446.1ZM49.08,439.87V422H56.6v17.88Zm0,48.16V470.16H56.6V488Zm0,30.29H56.6v17.87H49.08ZM1075.46,618.93a11.33,11.33,0,0,1-11.31,11.31H45.61a11.33,11.33,0,0,1-11.32-11.31V583.58H1075.46Zm28-66.84h-97.76a3.12,3.12,0,0,0,0,6.24h97.76v12.16a6.85,6.85,0,0,1-6.85,6.85H13.09a6.86,6.86,0,0,1-6.86-6.85V558.33H88.81a3.12,3.12,0,1,0,0-6.24H6.23v-2.81a6.86,6.86,0,0,1,6.86-6.85H1096.66a6.85,6.85,0,0,1,6.85,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M135.36,552.09H117.91a3.12,3.12,0,1,0,0,6.24h17.45a3.12,3.12,0,0,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M190.23,552.09H165.29a3.12,3.12,0,1,0,0,6.24h24.94a3.12,3.12,0,1,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M388.08,552.09H213.51a3.12,3.12,0,1,0,0,6.24H388.08a3.12,3.12,0,1,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M448.77,552.09H425.49a3.12,3.12,0,0,0,0,6.24h23.28a3.12,3.12,0,0,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M490.33,552.09h-10.8a3.12,3.12,0,1,0,0,6.24h10.8a3.12,3.12,0,0,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M728.09,552.09h-207a3.12,3.12,0,0,0,0,6.24h207a3.12,3.12,0,1,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M777.14,552.09H753a3.12,3.12,0,0,0,0,6.24h24.11a3.12,3.12,0,0,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M959.19,552.09H814.55a3.12,3.12,0,0,0,0,6.24H959.19a3.12,3.12,0,0,0,0-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M103.67,531.73h9.2a1.87,1.87,0,0,0,0-3.74h-9.2A1.87,1.87,0,0,0,103.67,531.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M122.22,531.57a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,122.22,531.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M241.15,526.32H238a1.87,1.87,0,1,0,0,3.74h3.12a1.87,1.87,0,1,0,0-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M242.81,441.11a2.48,2.48,0,0,0,2.49-2.49v-4.57a2.49,2.49,0,1,0-5,0v4.57A2.48,2.48,0,0,0,242.81,441.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M242.81,457.51a2.49,2.49,0,0,0,2.49-2.5v-4.54a2.49,2.49,0,1,0-5,0V455A2.49,2.49,0,0,0,242.81,457.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M242.81,473.12a2.49,2.49,0,0,0,2.49-2.49V467a2.49,2.49,0,0,0-5,0v3.59A2.49,2.49,0,0,0,242.81,473.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M254.24,450.26a2.49,2.49,0,0,0,2.49-2.5v-2.7a2.49,2.49,0,1,0-5,0v2.7A2.49,2.49,0,0,0,254.24,450.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M254.24,464.47a2.49,2.49,0,0,0,2.49-2.5v-2.7a2.49,2.49,0,0,0-5,0V462A2.49,2.49,0,0,0,254.24,464.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M254.24,478.68a2.49,2.49,0,0,0,2.49-2.5v-2.7a2.49,2.49,0,0,0-5,0v2.7A2.49,2.49,0,0,0,254.24,478.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M231.38,442.57a2.49,2.49,0,0,0-2.49,2.49v2.7a2.49,2.49,0,1,0,5,0v-2.7A2.49,2.49,0,0,0,231.38,442.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M231.38,456.78a2.48,2.48,0,0,0-2.49,2.49V462a2.49,2.49,0,1,0,5,0v-2.7A2.48,2.48,0,0,0,231.38,456.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M231.38,471a2.49,2.49,0,0,0-2.49,2.49v2.7a2.49,2.49,0,1,0,5,0v-2.7A2.49,2.49,0,0,0,231.38,471Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M356.8,527.78h-5.71a1.87,1.87,0,1,0,0,3.74h5.71a1.87,1.87,0,0,0,0-3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M339.55,448h-13.5a2.5,2.5,0,0,0-2.5,2.5V464a2.5,2.5,0,0,0,2.5,2.49h13.5a2.5,2.5,0,0,0,2.5-2.49V450.47A2.5,2.5,0,0,0,339.55,448Zm-2.49,13.51h-8.52V453h8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M339.55,473.33h-13.5a2.5,2.5,0,1,0,0,5h13.5a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M387.56,473.33H374.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M363.56,473.33H350.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M339.55,485.43h-13.5a2.5,2.5,0,1,0,0,5h13.5a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M387.56,485.43H374.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M363.56,485.43H350.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M339.55,497.54h-13.5a2.5,2.5,0,1,0,0,5h13.5a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M387.56,497.54H374.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M363.56,497.54H350.05a2.5,2.5,0,0,0,0,5h13.51a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M339.55,509.65h-13.5a2.49,2.49,0,1,0,0,5h13.5a2.49,2.49,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M387.56,509.65H374.05a2.49,2.49,0,0,0,0,5h13.51a2.49,2.49,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M363.56,509.65H350.05a2.49,2.49,0,0,0,0,5h13.51a2.49,2.49,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M458.74,529.65a1.25,1.25,0,0,0-1.24,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,458.74,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M463.21,529.65A1.24,1.24,0,0,0,462,530.9V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,463.21,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M467.68,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,0,0,2.5,0V530.9A1.25,1.25,0,0,0,467.68,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M472.15,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,0,0,2.5,0V530.9A1.25,1.25,0,0,0,472.15,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M476.62,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.24,1.24,0,0,0,476.62,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M481.09,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,481.09,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M485.55,529.65a1.25,1.25,0,0,0-1.24,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,485.55,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M615.34,529.65a1.24,1.24,0,0,0-1.24,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,615.34,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M619.81,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,0,0,2.5,0V530.9A1.25,1.25,0,0,0,619.81,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M624.28,529.65A1.25,1.25,0,0,0,623,530.9V533a1.25,1.25,0,0,0,2.5,0V530.9A1.25,1.25,0,0,0,624.28,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M628.75,529.65a1.25,1.25,0,0,0-1.25,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.24,1.24,0,0,0,628.75,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M633.22,529.65A1.25,1.25,0,0,0,632,530.9V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,633.22,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M637.68,529.65a1.25,1.25,0,0,0-1.24,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,637.68,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M642.15,529.65a1.24,1.24,0,0,0-1.24,1.25V533a1.25,1.25,0,1,0,2.49,0V530.9A1.25,1.25,0,0,0,642.15,529.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M546.24,474.57a20.16,20.16,0,1,0-20.16-20.16A20.18,20.18,0,0,0,546.24,474.57Zm0-35.33a15.18,15.18,0,1,1-15.17,15.17A15.19,15.19,0,0,1,546.24,439.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M569.31,436.33a10.39,10.39,0,1,0-10.39-10.39A10.4,10.4,0,0,0,569.31,436.33Zm0-15.79a5.41,5.41,0,1,1-5.4,5.4A5.4,5.4,0,0,1,569.31,420.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M557,286.88a2.46,2.46,0,0,0,1.45.47,2.49,2.49,0,0,0,1.46-4.52,22,22,0,0,1-6.79-8,2.5,2.5,0,0,0-4.46,2.24A27,27,0,0,0,557,286.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M567.68,291a2.5,2.5,0,0,0,.52,3.49,61.86,61.86,0,0,0,25.91,11.12,3.28,3.28,0,0,0,.43,0,2.49,2.49,0,0,0,.43-4.95,56.9,56.9,0,0,1-23.8-10.22A2.49,2.49,0,0,0,567.68,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M591.39,270.61a38.66,38.66,0,0,0,7.66,4.66,2.49,2.49,0,0,0,2.25-4.45,35.77,35.77,0,0,1-6.72-4,10.18,10.18,0,0,1-3.66-5.51,2.49,2.49,0,0,0-4.89,1A15.08,15.08,0,0,0,591.39,270.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M511.83,297.29a2.49,2.49,0,1,0,3-4,34.48,34.48,0,0,1-12.56-19,2.5,2.5,0,0,0-4.84,1.22A39.46,39.46,0,0,0,511.83,297.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M566.92,276.2a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,566.92,276.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M580.22,257.19a1.88,1.88,0,0,0,0-3.75A1.88,1.88,0,0,0,580.22,257.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M556.63,258.43a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,556.63,258.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M542.5,275.06a1.87,1.87,0,0,0,0,3.74A1.87,1.87,0,0,0,542.5,275.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M561.1,297.19a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,561.1,297.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M604.12,306.65a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,604.12,306.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M607.55,283.58a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,607.55,283.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M523,276.41a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,523,276.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M520.16,305.87a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,520.16,305.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M503.63,268.15a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,503.63,268.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M498.8,314a1.87,1.87,0,0,0,0-3.74A1.87,1.87,0,0,0,498.8,314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M531.5,341.58a2.49,2.49,0,0,0-3.24,1.4,8.6,8.6,0,0,1-16.54-2.13,2.49,2.49,0,1,0-5,.6,13.92,13.92,0,0,0,11.75,11.84,12.44,12.44,0,0,0,1.61.11,14,14,0,0,0,12.77-8.58A2.5,2.5,0,0,0,531.5,341.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M583.16,353.4a12.56,12.56,0,0,0,1.61-.11,13.93,13.93,0,0,0,11.75-11.84,2.49,2.49,0,1,0-4.95-.6A8.6,8.6,0,0,1,575,343a2.5,2.5,0,1,0-4.64,1.84A14,14,0,0,0,583.16,353.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M743.37,437.74a9.37,9.37,0,0,0,9.35-9.36V410A9.36,9.36,0,0,0,734,410v18.39A9.37,9.37,0,0,0,743.37,437.74ZM739,410a4.37,4.37,0,0,1,8.73,0v18.39a4.37,4.37,0,1,1-8.73,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M787.63,437.74a9.36,9.36,0,0,0,9.35-9.36V410a9.35,9.35,0,0,0-18.7,0v18.39A9.37,9.37,0,0,0,787.63,437.74ZM783.27,410a4.37,4.37,0,0,1,8.73,0v18.39a4.37,4.37,0,1,1-8.73,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M753.65,488.13H733.08a2.5,2.5,0,1,0,0,5h20.57a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M753.65,495.93H733.08a2.5,2.5,0,1,0,0,5h20.57a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M753.65,503.72H733.08a2.5,2.5,0,1,0,0,5h20.57a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M753.65,511.51H733.08a2.5,2.5,0,1,0,0,5h20.57a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M753.65,519.31H733.08a2.5,2.5,0,1,0,0,5h20.57a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M797.92,488.13H777.34a2.5,2.5,0,0,0,0,5h20.58a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M797.92,495.93H777.34a2.5,2.5,0,0,0,0,5h20.58a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M797.92,503.72H777.34a2.5,2.5,0,0,0,0,5h20.58a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M797.92,511.51H777.34a2.5,2.5,0,0,0,0,5h20.58a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M797.92,519.31H777.34a2.5,2.5,0,0,0,0,5h20.58a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M743.37,445.27a2.29,2.29,0,1,0,2.28,2.29A2.28,2.28,0,0,0,743.37,445.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M743.37,455.25a2.29,2.29,0,1,0,2.28,2.28A2.28,2.28,0,0,0,743.37,455.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 743.37,
    cy: 467.51,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 743.37,
    cy: 477.48,
    r: 2.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M787.63,445.27a2.29,2.29,0,1,0,2.29,2.29A2.28,2.28,0,0,0,787.63,445.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M787.63,455.25a2.29,2.29,0,1,0,2.29,2.28A2.28,2.28,0,0,0,787.63,455.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 787.63,
    cy: 467.51,
    r: 2.29,
    transform: "translate(52.95 1014.47) rotate(-67.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 787.63,
    cy: 477.48,
    r: 2.29,
    transform: "translate(43.74 1020.61) rotate(-67.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M877.93,526.53h2.5a2.5,2.5,0,0,0,0-5h-2.5a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M954.62,533.6h2.91a2.5,2.5,0,1,0,0-5h-2.91a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M967.57,430.58l-.27,23.57a3.13,3.13,0,0,0,2.07,3,3.18,3.18,0,0,0,1,.18,3.1,3.1,0,0,0,2.43-1.16l14-17.46a48,48,0,1,0-19.26-8.1Zm27.79-80.91a41.78,41.78,0,1,1-9.1,82.54,3.13,3.13,0,0,0-3.11,1.09l-9.51,11.88.18-16.19a3.13,3.13,0,0,0-1.4-2.64,41.77,41.77,0,0,1,22.94-76.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M931.44,458.29a2.5,2.5,0,0,0-.09,3.53L941.9,473a2.5,2.5,0,0,0,3.53.1,2.51,2.51,0,0,0,.1-3.53L935,458.39A2.51,2.51,0,0,0,931.44,458.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M954.2,449.68a2.49,2.49,0,0,0-1.86,3l2.11,8.93a2.5,2.5,0,0,0,2.42,1.92,2.22,2.22,0,0,0,.57-.07,2.48,2.48,0,0,0,1.86-3l-2.1-8.92A2.49,2.49,0,0,0,954.2,449.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M992.88,457.65,981.47,466A2.5,2.5,0,0,0,983,470.5a2.53,2.53,0,0,0,1.47-.48l11.41-8.34a2.5,2.5,0,1,0-3-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M993.74,398.41a13.57,13.57,0,0,1-8.47-3.24l-4.73,7.47s3.49,4.73,11.46,5.73v4h6.47v-4s11.7-1.5,11.7-11c0-11-13.44-11-13.44-13.44,0-.75.74-1.49,2-1.49,3.48,0,6.47,2.73,6.47,2.73l4.73-7.47a18,18,0,0,0-11.45-5.47v-3.74H992v4.23s-9.71,2.5-9.71,10.71c0,11,13.44,11,13.44,13.45C995.73,397.66,995,398.41,993.74,398.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1018.28,412.27a27.35,27.35,0,0,1-10.83,7.74,2.5,2.5,0,0,0,.91,4.82,2.66,2.66,0,0,0,.91-.17,32.4,32.4,0,0,0,12.81-9.17,2.49,2.49,0,0,0-3.8-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1006.3,363.65a28,28,0,0,1,20.08,36.76,2.5,2.5,0,0,0,4.7,1.69,33,33,0,0,0-23.67-43.31,2.49,2.49,0,1,0-1.11,4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M961.48,385.21a2.5,2.5,0,0,0,2.5-2.5v-.2a2.5,2.5,0,1,0-5,0v.2A2.49,2.49,0,0,0,961.48,385.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M964.86,376.59a2.47,2.47,0,0,0,1.2.31,2.5,2.5,0,0,0,2.19-1.28,23.71,23.71,0,0,1,8.39-8.75,2.49,2.49,0,1,0-2.59-4.26,28.7,28.7,0,0,0-10.17,10.59A2.5,2.5,0,0,0,964.86,376.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M113.13,349.14H221a20.91,20.91,0,0,0,20.89-20.88V155.45A20.91,20.91,0,0,0,221,134.57H113.13a20.91,20.91,0,0,0-20.89,20.88V328.26A20.91,20.91,0,0,0,113.13,349.14ZM98.47,155.45a14.67,14.67,0,0,1,14.66-14.65H221a14.66,14.66,0,0,1,14.65,14.65V328.26A14.66,14.66,0,0,1,221,342.91H113.13a14.67,14.67,0,0,1-14.66-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M113.13,336.05H221a7.8,7.8,0,0,0,7.79-7.79V155.45a7.8,7.8,0,0,0-7.79-7.79H113.13a7.81,7.81,0,0,0-7.8,7.79V328.26A7.81,7.81,0,0,0,113.13,336.05Zm-2.81-180.6a2.81,2.81,0,0,1,2.81-2.8H221a2.8,2.8,0,0,1,2.8,2.8V328.26a2.8,2.8,0,0,1-2.8,2.8H113.13a2.81,2.81,0,0,1-2.81-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M140.17,170.43a5.38,5.38,0,0,1-3.36-1.28l-1.88,3s1.78,2.38,6.13,2.38c3.46,0,5.63-2.18,5.63-4.45,0-4.35-5.33-4.35-5.33-5.34,0-.3.29-.59.79-.59a4.4,4.4,0,0,1,2.57,1.08l1.88-3a7.09,7.09,0,0,0-5.34-2.18c-3.46,0-5.64,2.18-5.64,4.45,0,4.35,5.34,4.35,5.34,5.34C141,170.14,140.67,170.43,140.17,170.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M153.42,172.21H156l.39,2h5.73s-4-13.76-4.05-13.84h-6.72l-4.05,13.84H153Zm1.28-6.72.69,3.56H154Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "173.98 169.64 168.64 169.64 168.64 160.35 163.5 160.35 163.5 174.19 173.98 174.19 173.98 169.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "186.63 170.24 180.7 170.24 180.7 169.25 185.84 169.25 185.84 165.29 180.7 165.29 180.7 164.31 186.23 164.31 186.23 160.35 175.56 160.35 175.56 174.19 186.63 174.19 186.63 170.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M192.66,170.43a5.38,5.38,0,0,1-3.36-1.28l-1.88,3s1.78,2.38,6.13,2.38c3.46,0,5.63-2.18,5.63-4.45,0-4.35-5.34-4.35-5.34-5.34,0-.3.3-.59.79-.59a4.37,4.37,0,0,1,2.57,1.08l1.88-3a7.09,7.09,0,0,0-5.34-2.18c-3.45,0-5.63,2.18-5.63,4.45,0,4.35,5.34,4.35,5.34,5.34C193.45,170.14,193.15,170.43,192.66,170.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 320.28,
    y: 160.35,
    width: 5.14,
    height: 13.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "332.94 168.06 336.3 174.19 342.03 174.19 342.03 160.35 336.89 160.35 336.89 166.48 333.53 160.35 327.8 160.35 327.8 174.19 332.94 174.19 332.94 168.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M351.32,174.49a7.29,7.29,0,0,0,5.54-2.18l-2.38-3.75a4.37,4.37,0,0,1-2.57,1.08,2.37,2.37,0,0,1,0-4.74,4.35,4.35,0,0,1,2.57,1.09l2.38-3.76a7.29,7.29,0,0,0-5.54-2.18,7.22,7.22,0,1,0,0,14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M365.36,174.49c4.54,0,7.71-3.17,7.71-7.22s-3.17-7.22-7.71-7.22-7.71,3.17-7.71,7.22S360.81,174.49,365.36,174.49Zm0-9.59a2.38,2.38,0,1,1-2.18,2.37A2.24,2.24,0,0,1,365.36,164.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "380.19 166.48 382.56 174.19 386.71 174.19 389.08 166.48 389.08 174.19 394.22 174.19 394.22 160.35 386.91 160.35 384.63 167.86 382.36 160.35 375.05 160.35 375.05 174.19 380.19 174.19 380.19 166.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "407.66 170.24 401.73 170.24 401.73 169.25 406.87 169.25 406.87 165.29 401.73 165.29 401.73 164.31 407.27 164.31 407.27 160.35 396.59 160.35 396.59 174.19 407.66 174.19 407.66 170.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M124.76,185.9h84.59a2.5,2.5,0,0,0,0-5H124.76a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M310,349.14H417.91a20.91,20.91,0,0,0,20.88-20.88V155.45a20.91,20.91,0,0,0-20.88-20.88H310a20.91,20.91,0,0,0-20.88,20.88V328.26A20.91,20.91,0,0,0,310,349.14ZM295.39,155.45A14.66,14.66,0,0,1,310,140.8H417.91a14.67,14.67,0,0,1,14.65,14.65V328.26a14.67,14.67,0,0,1-14.65,14.65H310a14.66,14.66,0,0,1-14.65-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M674.57,296.15H934.83a20.91,20.91,0,0,0,20.89-20.88V155.45a20.91,20.91,0,0,0-20.89-20.88H674.57a20.91,20.91,0,0,0-20.88,20.88V275.27A20.91,20.91,0,0,0,674.57,296.15Zm-14.65-140.7a14.66,14.66,0,0,1,14.65-14.65H934.83a14.66,14.66,0,0,1,14.65,14.65V275.27a14.66,14.66,0,0,1-14.65,14.65H674.57a14.66,14.66,0,0,1-14.65-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M674.57,283.68H934.83a8.42,8.42,0,0,0,8.42-8.41V155.45a8.42,8.42,0,0,0-8.42-8.41H674.57a8.42,8.42,0,0,0-8.41,8.41V275.27A8.42,8.42,0,0,0,674.57,283.68Zm-2.18-128.23a2.19,2.19,0,0,1,2.18-2.18H934.83a2.19,2.19,0,0,1,2.18,2.18V275.27a2.19,2.19,0,0,1-2.18,2.18H674.57a2.19,2.19,0,0,1-2.18-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M310,336.05H417.91a7.81,7.81,0,0,0,7.79-7.79V155.45a7.81,7.81,0,0,0-7.79-7.79H310a7.81,7.81,0,0,0-7.79,7.79V328.26A7.81,7.81,0,0,0,310,336.05Zm-2.8-180.6a2.81,2.81,0,0,1,2.8-2.8H417.91a2.81,2.81,0,0,1,2.8,2.8V328.26a2.81,2.81,0,0,1-2.8,2.8H310a2.81,2.81,0,0,1-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M321.68,185.9h84.59a2.5,2.5,0,0,0,0-5H321.68a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M122.27,320.78h84.59a2.5,2.5,0,0,0,0-5h-82.1V204a2.49,2.49,0,0,0-5,0V318.29A2.49,2.49,0,0,0,122.27,320.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M787.63,265.56a2.5,2.5,0,0,0,2.5-2.5v-95.4a2.5,2.5,0,1,0-5,0v95.4A2.5,2.5,0,0,0,787.63,265.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M845.16,261.37l.08,0,.15.06a50.17,50.17,0,0,0,68.81-35.4l0-.14a50.07,50.07,0,0,0-7.74-39,3.19,3.19,0,0,0-.31-.44l0,0a50.1,50.1,0,0,0-79.09-3.66l-.08.06a2.72,2.72,0,0,0-.34.42,50.15,50.15,0,0,0,18.52,78.13Zm20-.82a45,45,0,0,1-15.35-2.69l16.83-33.39,42,3.16A45.29,45.29,0,0,1,865.17,260.55Zm45.2-45.2a45.69,45.69,0,0,1-.6,7.36l-38.42-2.89,32.41-28A45,45,0,0,1,910.37,215.35Zm-45.2-45.2a45.14,45.14,0,0,1,35.74,17.57l-35.59,30.72-33.17-33.9A45.09,45.09,0,0,1,865.17,170.15Zm-36.24,18.23,33.21,33.94L845.22,255.9a45.15,45.15,0,0,1-16.29-67.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M695.25,170.15h46.14a2.5,2.5,0,1,0,0-5H695.25a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M695.25,180.29h16.21a2.5,2.5,0,1,0,0-5H695.25a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M695.25,190.43h29.41a2.5,2.5,0,0,0,0-5H695.25a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M695.25,200.56h41.57a2.5,2.5,0,0,0,0-5H695.25a2.5,2.5,0,0,0,0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M695.25,265.56h48.12a2.5,2.5,0,0,0,2.49-2.5V212.71a2.49,2.49,0,0,0-2.49-2.49H695.25a2.49,2.49,0,0,0-2.49,2.49v50.35A2.5,2.5,0,0,0,695.25,265.56Zm2.5-50.36h43.12v45.37H697.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M133.6,253.65a2.5,2.5,0,0,0-2.5,2.5V307a2.49,2.49,0,0,0,2.5,2.49H152a2.49,2.49,0,0,0,2.49-2.49V256.15a2.5,2.5,0,0,0-2.49-2.5Zm15.85,50.82H136.09V258.64h13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M162.3,243.37a2.49,2.49,0,0,0-2.5,2.49V307a2.49,2.49,0,0,0,2.5,2.49h18.35a2.48,2.48,0,0,0,2.49-2.49v-61.1a2.48,2.48,0,0,0-2.49-2.49Zm15.85,61.1H164.79V248.35h13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M209.35,214.06H191a2.49,2.49,0,0,0-2.49,2.5V307a2.48,2.48,0,0,0,2.49,2.49h18.35a2.48,2.48,0,0,0,2.49-2.49v-90.4A2.49,2.49,0,0,0,209.35,214.06Zm-2.49,90.41H193.49V219.05h13.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M321.63,320.78h84.58a2.5,2.5,0,1,0,0-5H324.12V204a2.5,2.5,0,0,0-5,0V318.29A2.5,2.5,0,0,0,321.63,320.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M333,253.65a2.5,2.5,0,0,0-2.49,2.5V307a2.49,2.49,0,0,0,2.49,2.49H351.3a2.49,2.49,0,0,0,2.5-2.49V256.15a2.5,2.5,0,0,0-2.5-2.5Zm15.86,50.82H335.45V258.64h13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M361.66,243.37a2.49,2.49,0,0,0-2.5,2.49V307a2.49,2.49,0,0,0,2.5,2.49H380A2.49,2.49,0,0,0,382.5,307v-61.1a2.49,2.49,0,0,0-2.49-2.49Zm15.85,61.1H364.15V248.35h13.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M390.36,214.06a2.5,2.5,0,0,0-2.5,2.5V307a2.49,2.49,0,0,0,2.5,2.49h18.35A2.49,2.49,0,0,0,411.2,307v-90.4a2.5,2.5,0,0,0-2.49-2.5Zm15.85,90.41H392.85V219.05h13.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_8",
    "data-name": "Ebene 8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.02,
    y: 157.09,
    width: 71.21,
    height: 20.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 316.06,
    y: 156.89,
    width: 98.88,
    height: 20.76
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.3bba339ff3cac2ca377f1d0e20973240.svg";
export { ForwardRef as ReactComponent };